import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"
import {Link} from "gatsby"
import {kebabCase, lowerCase} from "lodash"

const Post = ({post, sticky = false}) => {
  const {
    excerpt,
    slug,
    frontmatter: {title, date, categories = []}
  } = post

  const stickyStyle = sticky ? styles.Sticky : null
  return (
    <div className={cx(stickyStyle, styles.Post)}>
      <Link to={`/blog/${slug}`}>
        <h2>{title}</h2>
        <p>{excerpt}</p>
        <p>
          <small>{date}</small>
        </p>
      </Link>
      <p>
        {categories.map((c, idx) => (
          <Link
            key={idx}
            to={`/blog/categories/${kebabCase(c)}`}
            className={cx(styles.hashtags)}
          >
            #{lowerCase(`${c}`)}
            {idx < categories.length - 1 ? ", " : null}
          </Link>
        ))}
      </p>
    </div>
  )
}

export default Post
